import React from 'react';
import { Box, Grid } from '@mui/material';
import { HumbeeLogo } from '../../../components/icon';
import HumbeeBanner from '../Utils/Assets/src/HumbeeBanner.png';

const OnboardingContainer = ({ children }) => {
  return (
    <Grid
      container
      sx={{
        height: '100vh',
        width: '100vw',
      }}
    >
      <Grid
        item
        xs={0}
        md={6}
        sx={{
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <HumbeeLogo />
        <img
          src={HumbeeBanner}
          alt='Humbee Banner'
          style={{
            margin: '50px 50px',
            width: '100%',
            height: 'auto',
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        alignContent='center'
      >
        <Box
          height={'100vh'}
          sx={{
            boxShadow: 5,
            background: 'linear-gradient(to bottom, #191919, #5B5B5B)',
            height: window.innerHeight,
            overflowY: 'auto',
            display: 'flex',
            alignItems: 'center',
            paddingY: '2rem',
          }}
        >
          <Box
            sx={{ width: '80%', margin: 'auto' }}
          >
            {children}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default OnboardingContainer;
